import { render } from "./RegisterAndLoginPanel.vue?vue&type=template&id=6c80624a&scoped=true"
import script from "./RegisterAndLoginPanel.vue?vue&type=script&lang=js"
export * from "./RegisterAndLoginPanel.vue?vue&type=script&lang=js"

import "./RegisterAndLoginPanel.vue?vue&type=style&index=0&id=6c80624a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c80624a"]])

export default __exports__